import { Tag } from '@varo/graphql-schema-types';
import React from 'react';
import { StyleSheet, View } from 'react-native';
import { Tag as TagComponent } from 'shared/components/vxl/Tag/Tag';
import { propsFromTag } from 'shared/components/vxl/Tag/Tag.helpers';
import theme from 'shared/styles/theme';

interface DepositStatusTagProps {
  statusTag: Tag;
}

const DepositStatusTag = ({ statusTag }: DepositStatusTagProps) => {
  const tagProps = propsFromTag(statusTag);

  if (!tagProps) {
    return null;
  }

  return (
    <View style={styles.tag}>
      <TagComponent {...tagProps} />
    </View>
  );
};

export default DepositStatusTag;

const styles = StyleSheet.create({
  tag: {
    marginHorizontal: theme.spacing.m,
    marginTop: theme.spacing.m,
  },
});
